import { Box } from "@mui/material";
import { FC } from "react";

interface IReturnBalance {
    num: number;
}

export const ReturnBalance: FC<IReturnBalance> = ({ num }) => {

    return <>
        <Box sx={{ fontWeight: 700, fontSize: 17 }} component="span">$</Box> {new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num)}
    </>;
};
